exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".buttonTextBox__InvoiceFinalizationSection-module___1hnBO {\n    font-size: 14px;\n    align-items:center;\n}\n\n@media (max-width: 425px) {\n    .buttonTextBox__InvoiceFinalizationSection-module___1hnBO {\n        font-size: 12px;\n    }\n}", ""]);

// Exports
exports.locals = {
	"buttonTextBox": "buttonTextBox__InvoiceFinalizationSection-module___1hnBO"
};